import React from "react";
import { getRainSourceLabel } from "../../utils/agriculturalEvents";
import "./RainSourceBadge.css";

export default function RainSourceBadge({ event, t }) {
  const label = getRainSourceLabel(event, t);
  return label ? <span className="rain-source-badge" title={label}>{label}</span> : null;
}
